import { getTestIds } from 'seagull/utils/TestIds';
export const GetRecipientsDropdownTID = (parentTestId)=>getTestIds(parentTestId);
